import type { JsonWireObject as JsonObject, JsonWireValue as JsonValue } from "./json-value.ts";
import Ajv, { type ValidateFunction } from "ajv";
import addFormats from "ajv-formats";

const ajv = new Ajv({ allErrors: true, strict: true, allowUnionTypes: false });
addFormats(ajv);

export function compileJsonSchema(schema: JsonObject, label: string): ValidateFunction {
  try {
    return ajv.compile(schema);
  } catch (error) {
    throw new Error(`${label} is not a supported JSON Schema: ${errorMessage(error)}`);
  }
}

export function assertMatchesJsonSchema(
  schema: JsonObject,
  value: JsonValue,
  label: string
): void {
  const validate = compileJsonSchema(schema, label);
  if (!validate(value)) {
    throw new Error(`${label} validation failed: ${ajv.errorsText(validate.errors)}`);
  }
}

function errorMessage(error: unknown): string {
  return error instanceof Error ? error.message : String(error);
}
